import { StepConfig, StepperConfig } from '@mydocma/import-export';

export const step1: StepConfig = {
  name: 'selectTemplate',
  label: 'MM.reporting.writing.tabs.template',
  icon: {
    number: '_send-letter',
    edit: '_send-letter',
    done: '_send-letter'
  },
  optional: false,
  editable: true,
  enabled: true
};

export const step2: StepConfig = {
  name: 'selectOptions',
  label: 'MM.reporting.writing.tabs.options',
  icon: {
    number: 'toggle_off',
    edit: 'toggle_off',
    done: 'toggle_off'
  },
  optional: false,
  editable: true,
  enabled: true
};

export const step3: StepConfig = {
  name: 'showPreview',
  label: 'MM.reporting.writing.tabs.preview',
  icon: {
    number: 'remove_red_eye',
    edit: 'remove_red_eye',
    done: 'remove_red_eye'
  },
  optional: false,
  editable: true,
  enabled: true
};

export const step4: StepConfig = {
  name: 'selectCreationType',
  label: 'MM.reporting.writing.tabs.creating',
  icon: {
    number: 'done',
    edit: 'done',
    done: 'done'
  },
  optional: false,
  editable: true,
  enabled: true
};

export const step5: StepConfig = {
  name: 'selectEmail',
  label: 'MM.reporting.writing.tabs.email',
  icon: {
    number: 'mail',
    edit: 'mail',
    done: 'mail'
  },
  optional: false,
  editable: true,
  enabled: true
};



export const writingStepperConfig: StepperConfig = {
  steps: [
    step1,
    step2,
    step3,
    step4,
    step5
  ]
};
